import React from 'react'

import { Button, FilteredSearchBar } from 'src/chrome'
import { SearchFilter } from 'src/chrome/FilteredSearchBar/types'
import { Memoized } from 'src/hooks/dependencies'

import styles from '../../containers/contactManager.module.scss'

type Props = {
  onOpenContacts: () => void
  onAdd: () => void
  filters: SearchFilter[]
  setFilters: Memoized<(filters: SearchFilter[]) => void>
  setTerms: Memoized<(terms: string) => void>
  onImport: () => void
}

const ContactHeader: React.FC<Props> = props => {
  const {
    filters,
    onOpenContacts,
    onImport,
    setTerms,
    setFilters,
    onAdd,
  } = props

  return (
    <div className={styles.headerContainer}>
      <div className={styles.actionButtons}>
        <Button
          id={'import_csv_btn'}
          title={'Import Contacts'}
          icon={'CONTACT'}
          iconColor={'#6f8394'}
          iconSize={15}
          disabled={false}
          onClick={onImport}
          className={styles.importButton}
        />
        <Button
          title={'View Contacts'}
          className={styles.contextButton}
          icon={'FUNNEL'}
          iconColor={'#FFF'}
          iconSize={15}
          buttonColor={'pink'}
          onClick={onOpenContacts}
          id="view_contacts_btn"
        />
      </div>
      <div className={styles.searchBar}>
        <FilteredSearchBar
          filters={filters}
          className={styles.searchFilter}
          setTerms={setTerms}
          setFilters={setFilters}
          autocomplete={'off'}
        />
      </div>
      <div className={styles.addButton}>
        <Button
          title={'Add Group'}
          icon={'ADD'}
          iconColor={'#FFF'}
          iconSize={15}
          buttonColor={'pink'}
          onClick={onAdd}
          id="add_new_group_btn"
        />
      </div>
    </div>
  )
}

export default ContactHeader
